module.exports = __webpack_public_path__ + "img/order-proposal.cd12cdf6.svg";